"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSampleSearchDTO = instanceOfSampleSearchDTO;
exports.SampleSearchDTOFromJSON = SampleSearchDTOFromJSON;
exports.SampleSearchDTOFromJSONTyped = SampleSearchDTOFromJSONTyped;
exports.SampleSearchDTOToJSON = SampleSearchDTOToJSON;
exports.SampleSearchDTOToJSONTyped = SampleSearchDTOToJSONTyped;
/**
 * Check if a given object implements the SampleSearchDTO interface.
 */
function instanceOfSampleSearchDTO(value) {
    return true;
}
function SampleSearchDTOFromJSON(json) {
    return SampleSearchDTOFromJSONTyped(json, false);
}
function SampleSearchDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'searchString': json['searchString'] == null ? undefined : json['searchString'],
    };
}
function SampleSearchDTOToJSON(json) {
    return SampleSearchDTOToJSONTyped(json, false);
}
function SampleSearchDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'searchString': value['searchString'],
    };
}
